var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "edit-textfield",
          staticStyle: { position: "relative" },
          attrs: { xs12: "" },
        },
        [
          _c("v-textarea", {
            staticClass: "text-hiding",
            attrs: {
              "auto-grow": "",
              rows: "1",
              label: _vm.label,
              rules: _vm.rules,
            },
            model: {
              value: _vm.outputFormula,
              callback: function ($$v) {
                _vm.outputFormula = $$v
              },
              expression: "outputFormula",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "text-in-color" },
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "span",
                {
                  key: index,
                  staticClass: "text-in-color-item",
                  style: { color: _vm.styleLookUp[item.type] },
                },
                [_vm._v(_vm._s(item.value))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("v-textarea", {
            staticClass: "textfield-placeholder",
            attrs: { "auto-grow": "", rows: "1", label: _vm.label },
            model: {
              value: _vm.outputFormula,
              callback: function ($$v) {
                _vm.outputFormula = $$v
              },
              expression: "outputFormula",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "close-on-click": false,
            "offset-y": "",
            left: "",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _vm.useMenu
                    ? _c(
                        "v-btn",
                        _vm._g({ attrs: { icon: "" } }, on),
                        [_c("v-icon", [_vm._v("info")])],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _vm._v(" "),
          _c(
            "v-card",
            { attrs: { width: "500" } },
            [
              _c("v-card-text", [
                _c("div", [_vm._v(_vm._s(_vm.menuTitle))]),
                _c("br"),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v(_vm._s(_vm.Double) + ": ")]),
                  _vm._v(_vm._s(_vm.DoubleData)),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v(_vm._s(_vm.Equation) + ": ")]),
                  _vm._v(_vm._s(_vm.EquationData)),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v(_vm._s(_vm.Range) + ": ")]),
                  _vm._v(_vm._s(_vm.RangeData)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          _vm.menu = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }